import { useContext } from 'react';

import { ExperienceContext } from '@thd-nucleus/experience-context';
import { AppContext } from '@thd-nucleus/app-render';
import { FeaturesMap, ILink } from '../models/navigation';
import { routes } from '../constants/routes';

export const useAccountCrumbs = (additionalCrumbs: ILink[] = []): ILink[] => {
  const { customer, channel } = useContext(ExperienceContext);
  const { instance } = useContext(AppContext);
  const isB2B = customer?.type?.toUpperCase() === 'B2B';
  const isMobile = channel === 'mobile';

  const {
    ENABLE_NEW_B2C_PREFERENCE_LINK,
    ENABLE_NEW_PAYMENTS_PAGE,
    ENABLE_NEW_PROXTRA_PRICING_PAGE,
    ENABLE_NUCLEUS_QUOTE_EXPERIENCE,
    ENABLE_NEW_ADDMANAGE_USERS,
    ENABLE_NEW_PERKS_PAGE,
    ENABLE_NEW_ACCOUNT_DASHBOARD,
    ENABLE_NEW_PURCHASE_HISTORY_PAGE,
    ENABLE_NEW_POJOBS,
  } = instance?.expConfiguration || {};

  const featuresMap: FeaturesMap = {
    ENABLE_NEW_B2C_PREFERENCE_LINK: ENABLE_NEW_B2C_PREFERENCE_LINK === 'true',
    ENABLE_NEW_PAYMENTS_PAGE: ENABLE_NEW_PAYMENTS_PAGE === '1',
    ENABLE_NEW_PROXTRA_PRICING_PAGE: ENABLE_NEW_PROXTRA_PRICING_PAGE === '1',
    ENABLE_NEW_PERKS_PAGE: ENABLE_NEW_PERKS_PAGE === '1',
    ENABLE_NUCLEUS_QUOTE_EXPERIENCE: ENABLE_NUCLEUS_QUOTE_EXPERIENCE === 'true',
    ENABLE_NEW_ADDMANAGE_USERS: ENABLE_NEW_ADDMANAGE_USERS === '1',
    ENABLE_NEW_ACCOUNT_DASHBOARD: ENABLE_NEW_ACCOUNT_DASHBOARD === '1',
    ENABLE_NEW_PURCHASE_HISTORY_PAGE: ENABLE_NEW_PURCHASE_HISTORY_PAGE === '1',
    ENABLE_NEW_POJOBS: ENABLE_NEW_POJOBS === '1',
  };

  const getB2CAccountCrumb = () => {
    if (featuresMap.ENABLE_NEW_ACCOUNT_DASHBOARD) {
      return routes.b2cDashboard;
    }
    return isMobile ? routes.b2cMobileMenu : routes.profile;
  };

  const b2cAccountCrumb = getB2CAccountCrumb();

  const accountCrumb = {
    path: isB2B ? routes.b2bDashboard.path(featuresMap) : b2cAccountCrumb.path,
    label: 'Account',
  };
  return [{ path: '/', label: 'Home' }, accountCrumb, ...additionalCrumbs];
};
